/**
 * Author: Claude Code
 * Version: v3.2.17
 * Modified: 2025-10-03
 *
 * TopBar - 顶部状态栏（Logo + 回合数 + 存活数 + 用户余额）
 */

import React from 'react';

export interface TopBarDataProps {
  currentRound: number;
  aliveCount: number;
  userBalance: number;
  totalCount?: number;
}

export interface TopBarProps {
  // 兼容两种用法：单字段 props 或 data 对象
  data?: Partial<TopBarDataProps>;
  currentRound?: number;
  aliveCount?: number;
  userBalance?: number;
}

export const TopBar: React.FC<TopBarProps> = ({ data, currentRound, aliveCount, userBalance }) => {
  const roundVal = typeof data?.currentRound === 'number' ? data!.currentRound : (typeof currentRound === 'number' ? currentRound : 0);
  const aliveVal = typeof data?.aliveCount === 'number' ? data!.aliveCount : (typeof aliveCount === 'number' ? aliveCount : 0);
  const balanceVal = typeof data?.userBalance === 'number' ? data!.userBalance : (typeof userBalance === 'number' ? userBalance : 0);
  return (
    <div className="top-bar">
      <div className="top-bar-left">
        <div className="game-logo">
          <span className="logo-icon">🎮</span>
          <span className="logo-text">Agent Battle Royale</span>
        </div>
      </div>

      <div className="top-bar-center">
        <div className="stat-item">
          <span className="stat-label">ROUND</span>
          <span className="stat-value">{roundVal}</span>
        </div>
        <div className="stat-divider">|</div>
        <div className="stat-item">
          <span className="stat-label">ALIVE</span>
          <span className="stat-value alive">{aliveVal}</span>
        </div>
      </div>

      <div className="top-bar-right">
        <div className="balance-display">
          <span className="balance-icon">💰</span>
          <span className="balance-label">Balance:</span>
          <span className="balance-value">{Number(balanceVal || 0).toLocaleString()} momo</span>
        </div>
      </div>
    </div>
  );
};
